import { ActivityEntityName } from '../shared/activity.entity.name';
import { Attachment } from '../shared/attachment';
import { AuditDetails, Entity } from '../entity';
import { AfterSubmitType, AlignType, InputStyleType } from './enums';
import { MetadataEntityFieldData } from '../../metadata/entity/decorators/model/metadata.entity.field.data';

export interface EntityForm extends Entity, AuditDetails {

    description?: string;
    entity: ActivityEntityName;

    showLogo?: boolean;
    logoSource?: Entity;
    logo?: Attachment;

    showTitle?: boolean;
    title?: string;

    afterSubmit: AfterSubmitType;
    redirectUrl?: string;
    thankMessage?: string;

    options: string[]; // path
    optionsOverride?: EntityOptionOverride;
    defaultValue?: any; // { [path: string]: any}

    style: EntityStyleOption;

    copyId?: string;


}

export interface EntityFieldOption extends MetadataEntityFieldData {

    description?: string;
    placeholder?: string;
    defaultValue?: any;

}



export interface EntityStyleOption {
    inputStyle: InputStyleType;

    textFont: string;
    textSize: string;

    titleFontSize: string;

    buttonStyle: EntityButtonStyle;
}


export interface EntityButtonStyle {
    label?: string;
    labelColor?: string;
    backgroundColor?: string;
    align?: AlignType;
}


export type EntityOptionOverride = { [path: string]: Partial<EntityFieldOption> }

/*== DEFAULT VALUE  ==*/

export const defaultSubmitButtonStyle: EntityButtonStyle = {
    label: 'Submit',
    labelColor: '#FFF',
    backgroundColor: '#4F92E1',
    align: AlignType.Center,
}

export const defaultStyle: EntityStyleOption = {
    inputStyle: InputStyleType.Default,
    textFont: 'inter',
    textSize: '8pt',
    titleFontSize: '12pt',
    buttonStyle: defaultSubmitButtonStyle,
}

export const defaultEntityForm: Partial<EntityForm> = {
    _id: null,
    active: true,
    options: undefined,
    style: defaultStyle,

    afterSubmit: AfterSubmitType.Thank,
    thankMessage: 'Thank you for submitting the form.',
}

export const defaultEntityForms: { [key: string]: Partial<EntityForm> } = {
    [ActivityEntityName.Lead.toLocaleLowerCase()]: {
        ...defaultEntityForm,
        entity: ActivityEntityName.Lead,
    },
}